import Page from '@/components/Page/Page';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import { PageModel } from '@/models/page';
import BackToTopButton from '@uikit/components/BackToTopButton/BackToTopButton';
import Layout from '@uikit/components/Layout/Layout';
import RegioFooter from '@uikit/components/RegioFooter/RegioFooter';
import RegioHeader from '@uikit/components/RegioHeader/RegioHeader';
import RegioPageGasContent from '@uikit/components/RegioPageContent/RegioPageGasContent';
import { RegioPageProps } from './types';

const RegioPowerGas = (pageData: PageModel<RegioPageProps>): JSX.Element => {
  const meta = extractPageMetaFromRouteData(pageData);
  const { props } = pageData;

  useInitialPageDataLayer();

  return (
    <Layout>
      <Page meta={meta}>
        <RegioHeader />
        <RegioPageGasContent {...props} />
      </Page>

      <BackToTopButton footerOffset={0} />

      <RegioFooter />
    </Layout>
  );
};
export default RegioPowerGas;
